import { createFileRoute, notFound } from '@tanstack/react-router';
import { ReportViewerLayout } from '../../../../../../pages/interpretiveReports/ReportViewer';
import { interpretiveReportQueryOptions } from '../../../../../../services/queries';
import {
  READ_ORGANIZATION_INTERPRETIVE_REPORTS,
  READ_PLATFORM_INTERPRETIVE_REPORTS,
  READ_USER_INTERPRETIVE_REPORTS,
} from '../../../../../../utils/permissions';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/reports/$reportId'
)({
  staticData: { ddViewName: 'experiments-report-viewer' },
  beforeLoad: ({ context }) => {
    const canReadReports =
      context.auth.hasPermission(READ_USER_INTERPRETIVE_REPORTS) ||
      context.auth.hasPermission(READ_ORGANIZATION_INTERPRETIVE_REPORTS) ||
      context.auth.hasPermission(READ_PLATFORM_INTERPRETIVE_REPORTS);
    if (!canReadReports) {
      throw notFound();
    }
  },
  loader: async ({ context, params }) => {
    try {
      await context.queryClient.ensureQueryData(
        interpretiveReportQueryOptions(
          params.reportId,
          context.auth.hasPermission
        )
      );
      return { reportId: params.reportId };
    } catch {
      throw notFound();
    }
  },
  component: ReportViewerLayout,
});
